"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Base action types from type

var makeActionTypes = exports.makeActionTypes = function makeActionTypes(type) {
  return {
    main: type,
    loading: type + "_LOADING",
    success: type + "_SUCCESS",
    failure: type + "_FAILURE",
    unload: type + "_UNLOAD"
  };
}; // Barebone actions from type


var makeActions = exports.makeActions = function makeActions(type) {
  var actionTypes = makeActionTypes(type);

  var load = function load() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return {
      type: actionTypes.main,
      payload: {
        params: params
      },
      meta: meta
    };
  };

  var unload = function unload() {
    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      type: actionTypes.unload,
      meta: meta
    };
  };

  return {
    load: load,
    unload: unload
  };
};